// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js
export default {
    image1: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6988648e78bcc458a4397827_monday-sidekick-logo.svg",
        alt: ""
    },
    image2: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6995a88664d77a4bd3dd44d8_sidekick-circle.avif",
        alt: ""
    },
    image3: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6995a5f6241e7615d45323f7_sidekick-border.svg",
        alt: ""
    },
    link1: {
        href: "#",
        target: "_self"
    },
    link2: {
        href: "https://monday.com/w/sidekick",
        target: "_self"
    },
    text1: "Accelerate your execution with an intelligent, context-aware AI assistant who thinks, recommends, and runs work for you at scale.",
    text2: "Get Started",
    text3: "Learn more <br />",
    text5: "Create a project plan",
    text6: "Research venues for conference",
    text7: "Analyze sales pipeline",
    title: "Move work forward with <br /> a built-in AI assistant"
};
